import { render, staticRenderFns } from "./CardDefault.vue?vue&type=template&id=23064c4a"
import script from "./CardDefault.vue?vue&type=script&lang=js"
export * from "./CardDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports